import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/channels/guest/$channelId/thread/$threadId` activates the
// reply-thread column (col 3). The Channels LAYOUT route (channels.tsx) reads
// `$threadId` off the leaf match and renders the ThreadPanel via ColumnLayout.
// Reply threads are gated OFF for guest-facing channels in practice, but the
// marker exists so the route shape stays symmetric with internal.
export const Route = createFileRoute(
  "/$orgSlug/$eventSlug/channels/guest/$channelId/thread/$threadId",
)({
  component: () => null,
})
